import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKdesuLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#08437f",
			d: "M 32,4 32,60 4,32 Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ececec",
			d: "M 32,4 60,32 H 32 Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#d80c13",
			d: "M 60,32 32,60 V 32 Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e9cc0c",
			d: "M 32,12 37,32 32,52 27,32 Z"
		})
	]
});
export default SvgKdesuLogo;
